<!-- StockFormComponent.vue -->
<template>
  <dialog :open="show" class="stock-dialog">
    <div class="dialog-content">
      <div class="dialog-header">
        <h2>Editar stock</h2>
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>

      <form @submit.prevent="handleSubmit" v-if="producto">
        <div class="form-group">
          <label>Producto:</label>
          <input
            type="text"
            :value="producto.producto_nombre"
            disabled
          />
        </div>

        <div class="form-group">
          <label>Cantidad actual:</label>
          <input
            type="number"
            v-model.number="form.cantidad"
            required
          />
        </div>

        <div class="form-group">
          <label>Cantidad mínima:</label>
          <input
            type="number"
            v-model.number="form.minimo"
            required
          />
        </div>

        <div class="form-actions">
          <button type="button" class="cancel-btn" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="submit-btn">Guardar</button>
        </div>
      </form>
    </div>
  </dialog>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  show: Boolean,
  producto: { type: Object, required: true }
})
const emit = defineEmits(['close', 'save'])

const form = ref({ cantidad: 0, minimo: 0 })

watch(
  () => props.producto,
  (p) => {
    if (p) form.value = { cantidad: p.cantidad, minimo: p.minimo }
  },
  { immediate: true }
)

const handleSubmit = () => {
  emit('save', { id: props.producto.id, ...form.value })
}
</script>

<style scoped>
.stock-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(90vw, 400px);
  background: white;
  border-radius: 8px;
  border: none;
  padding: 1.5rem;
  box-shadow: 0 0 20px rgba(0,0,0,0.25);
  animation: fadeIn 0.25s ease-out;
  z-index: 1000;
}

::backdrop {
  background: rgba(0, 0, 0, 0.55);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
}

.close-btn:hover {
  color: #000;
}

.form-group {
  margin-bottom: 1rem;
}

input[type="number"], input[disabled] {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

input[disabled] {
  background: #f8f9fa;
  color: #555;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

.cancel-btn {
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.6rem 1.2rem;
  cursor: pointer;
}

.submit-btn {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.6rem 1.2rem;
  cursor: pointer;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translate(-50%, -45%); }
  to { opacity: 1; transform: translate(-50%, -50%); }
}
</style>
